import Article from 'dpl/prismic/article/components/Article';
import Hub from 'dpl/prismic/hub/components/Hub';

import { DOCUMENT_TYPES } from './customPropTypes';

export const DOCUMENT_TYPE_TO_COMPONENT = {
  [DOCUMENT_TYPES.ARTICLE]: Article,
  [DOCUMENT_TYPES.HUB]: Hub
};
